module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av401-6f42045999744491a455a3a472dfa8d6.jpg";